<div cdkDropList (cdkDropListDropped)="drop($event)">
  <div *ngFor="let text of listTexts; let i = index"
       class="input-group input-group-sm" [ngClass]="{'mt-1': i > 0}"
       cdkDrag
       (cdkDragStarted)="OnDragStart()"
       (cdkDragEnded)="OnDragEnd()"
       [cdkDragDisabled]="input.MainElementList[0].Disabled">
    <button cdkDragHandle class="grab q-btn q-bo q-white mr-1" style=" margin-bottom: 0.45rem; height: unset !important;">
      <i class="fas fa-grip-vertical q-c-dark-grey"></i>
    </button>
    <textarea #textearea
              rows="1"
              [id]="input.MainElementList[0].ID + i"
              class="col q-input-border"
              [disabled]="input.MainElementList[0].Disabled"
              [required]="input.MainElementList[0].Required"
              [ngClass]="setClass(input)"
              (keydown)="ResizeHeight(i, $event)"
              (change)="ChangeTextValue()"
              [(ngModel)]="text.Value"></textarea>
    <button *ngIf="!input.MainElementList[0].Disabled"
            (click)="RemoveText(i)"
            [id]="input.MainElementList[0].ID + '_minus_btn_' + i"
            class="mr-1 ml-0 rounded-right q-btn q-danger q-bo">
      <i class="fas fa-minus"></i>
    </button>
    <button *ngIf="!input.MainElementList[0].Disabled"
            [ngClass]="{'invisible': i + 1 < listTexts.length}"
            (click)="AddText()"
            [id]="input.MainElementList[0].ID + '_minus_btn_' + i"
            title="ajouter un nouveau lien"
            class="ml-1 mr-0 q-btn q-bo q-primary">
      <i class="fas fa-plus"></i>
    </button>


    <div class="input-group input-group-sm" [ngClass]="{'mt-1': i > 0}" *cdkDragPlaceholder>
      <button class="invisible q-btn q-bo q-white mr-1">
        <i class="fas fa-grip-vertical q-c-dark-grey"></i>
      </button>
      <textarea rows="1"
                [style.height]="textearea.style.height"
                [id]="input.MainElementList[0].ID + i"
                class="col q-input-border"
                [disabled]="input.MainElementList[0].Disabled"
                [required]="input.MainElementList[0].Required"
                [ngClass]="setClass(input)"
                [value]="text.Value"></textarea>
      <button *ngIf="!input.MainElementList[0].Disabled"
              class="invisible mr-1 ml-0 rounded-right q-btn q-danger q-bo">
        <i class="fas fa-minus"></i>
      </button>
      <button *ngIf="!input.MainElementList[0].Disabled"
              class="invisible ml-1 mr-0 q-btn q-bo q-primary">
        <i class="fas fa-plus"></i>
      </button>
    </div>
  </div>




</div>



